import { type FC } from 'react'
import classNames from 'classnames'
import { tagHueClass, UNCATEGORIZED_HUE, UNCATEGORIZED_ICON, WORKFLOW_CATEGORIES, type WorkflowCategoryKey } from '../workflowTags'
import styles from './Tags.module.scss'

interface CategoryIconProps {
  category: WorkflowCategoryKey | null
}

export const CategoryIcon: FC<CategoryIconProps> = ({ category }) => {
  const info = category === null ? null : WORKFLOW_CATEGORIES[category]
  const icon = info?.icon ?? UNCATEGORIZED_ICON
  const hue = info?.hue ?? UNCATEGORIZED_HUE
  return (
    <span
      className={classNames('d-inline-flex align-items-center justify-content-center rounded-2 flex-shrink-0', styles.categoryIcon, tagHueClass(hue))}
      aria-hidden='true'
    >
      <i className={classNames('bi', icon)} />
    </span>
  )
}
